import invariant from '../utils/invariant';

/**
 * @param {any} listener
 * @returns {void}
 */
function validateListener(listener) {
  invariant(typeof listener === 'function', 'listener expected a function, instead received %s.', listener);
}

/**
 * @returns {Object<string, function>}
 */
function createPubSub() {
  /**
   * @var {Array<function>}
   */
  var _listeners = [];

  /**
   * @return {Array<function>}
   */
  function listeners() {
    return [].concat(_listeners);
  }

  /**
   * @param {function} listener
   * @returns {boolean}
   */
  function unsubscribe(listener) {
    validateListener(listener);

    var lastIndex = _listeners.lastIndexOf(listener);

    if (lastIndex < 0) {
      return false;
    }

    _listeners.splice(lastIndex, 1);

    return true;
  }

  /**
   * @param {function} listener
   * @returns {function}
   */
  function subscribe(listener) {
    validateListener(listener);

    _listeners.push(listener);

    return function () {
      return unsubscribe(listener);
    };
  }

  /**
   * @param {Array<any>} args
   * @returns {boolean}
   */
  function publish() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!_listeners.length) {
      return false;
    }

    listeners().forEach(function (listener) {
      listener.apply(undefined, args);
    });

    return true;
  }

  return {
    listeners: listeners,
    subscribe: subscribe,
    unsubscribe: unsubscribe,
    publish: publish
  };
}

export default createPubSub;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/events/createPubSub.js
// module id = 791
// module chunks = 0